
import React from 'react';
import FAQItem from './FAQItem';

const FAQSection = () => {
  return (
    <div className="space-y-4">
      <FAQItem 
        question="How do I track my order?" 
        answer="You can track your order by logging into your account and visiting the 'My Orders' section. Alternatively, you can use the tracking number provided in your shipping confirmation email."
      />
      <FAQItem 
        question="What is your return policy?" 
        answer="We offer a 30-day return policy for most items. Products must be in their original condition with tags attached. Please visit our Returns page for more details and to initiate a return."
      />
      <FAQItem 
        question="How long does shipping take?" 
        answer="Standard shipping typically takes 3-5 business days within the country. International shipping can take 7-14 business days depending on the destination and customs clearance."
      />
      <FAQItem 
        question="Do you ship internationally?" 
        answer="Yes, we ship to over 100 countries worldwide. Shipping costs and delivery times vary by location. You can see the shipping options available to your country during checkout."
      />
      <FAQItem 
        question="How can I change or cancel my order?" 
        answer="If you need to change or cancel your order, please contact our customer service team as soon as possible. We can usually accommodate changes if the order hasn't been processed yet."
      />
      <FAQItem 
        question="What payment methods do you accept?" 
        answer="We accept all major credit cards (Visa, MasterCard, American Express, Discover), PayPal, Apple Pay, and Google Pay. For some regions, we also offer bank transfers and buy-now-pay-later options."
      />
    </div>
  );
};

export default FAQSection;
